import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */

export const obtenerPersonasActivas = () => {
    return axios.get(`${API_URL}/personas/activas`, {
        headers: getHeaders(),
    });
};

export const obtenerDatosCreacionPersonas = async () => {
    try {
        const resp = await axios.get(`${API_URL}/personas/datosCreacion`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const verPersona = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/personas/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const crearOEditarPersona = async (persona) => {
    const configs = { headers: getHeaders() };

    try {
        if (persona.id !== "") {
            const resp = await axios.put(
                `${API_URL}/personas/${persona.id}`,
                persona,
                configs
            );
            return resp.data;
        }

        const resp = await axios.post(`${API_URL}/personas`, persona, configs);
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const crearUsuario = async (persona) => {
    try {
        const resp = await axios.put(
            `${API_URL}/personas/usuario/${persona.id}`,
            persona,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectGeneros = async () => {
    try {
        const resp = await axios.get(`${API_URL}/generos/select`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTiposDocumentos = async () => {
    try {
        const resp = await axios.get(`${API_URL}/tipoDocumento/select`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectPaises = async () => {
    try {
        const resp = await axios.get(`${API_URL}/paises/select`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectDepartamentos = async (id_pais) => {
    try {
        const resp = await axios.get(
            `${API_URL}/departamentos/select/${id_pais}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectCiudades = async (id_departamento) => {
    try {
        const resp = await axios.get(
            `${API_URL}/ciudades/select/${id_departamento}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarPersona = async (id_persona) => {
    try {
        const resp = await axios.delete(`${API_URL}/personas/${id_persona}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarPersona = async (id_persona) => {
    try {
        const resp = await axios.get(
            `${API_URL}/personas/activar/${id_persona}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 * Metodo para loguearse como una persona desde la tabla de personas activas
 * @param {number} username
 * @returns
 */
export const ingresarPersona = async (username) => {
    try {
        const resp = await axios.get(
            `${API_URL}/personas/ingresar/${username}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerDatosCreacionContrato = async () => {
    try {
        const resp = await axios.get(`${API_URL}/contratos/obtenerDatos`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const crearContrato = async (contrato) => {
    try {
        const resp = await axios.post(`${API_URL}/contratos`, contrato, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
